import { render } from "./MediaThumbnail.vue?vue&type=template&id=9f2cef74&ts=true"
import script from "./MediaThumbnail.vue?vue&type=script&lang=ts"
export * from "./MediaThumbnail.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/wVusKqw4/0/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__